import { Effect } from 'effect';
import {
  type OkraClientOptions,
  type OkraEffectClient,
  OkraClientError,
  runOkraClient,
  useOkraClientEffect,
} from './client-runtime.js';
import type { ParseJob, ParseRequest } from './parse.js';

export { OkraClientError as ParseClientError };
export type {
  ParseFile,
  ParseJob,
  ParseJobProgress,
  ParseJobStatus,
  ParseParser,
  ParseRequest,
} from './parse.js';

export interface ParseClient {
  parse(payload: ParseRequest, signal?: AbortSignal): Promise<ParseJob>;
}

export interface ParseClientOptions extends OkraClientOptions {}

export const parseEffect = (
  options: ParseClientOptions,
  payload: ParseRequest,
): Effect.Effect<ParseJob, OkraClientError> =>
  useOkraClientEffect(
    options,
    (client) => client.parse.createParse({ payload }) as Effect.Effect<ParseJob, unknown>,
    'Parse request failed',
  );

/** Generated-path Effect client for the core Unstructured-shaped parse call. */
export function makeParseClient(options: ParseClientOptions): ParseClient {
  return {
    parse: (payload, signal) =>
      runOkraClient(
        options,
        (client: OkraEffectClient) =>
          client.parse.createParse({ payload }) as Effect.Effect<ParseJob, unknown, never>,
        'Parse request failed',
        signal,
      ),
  };
}
